"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ModalBase;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _clsx5 = _interopRequireDefault(require("clsx"));
var _context7 = _interopRequireDefault(require("../Theme/context"));
var _context8 = _interopRequireDefault(require("./context"));
var _Container = _interopRequireDefault(require("../Container"));
var defaultStyle = require("./../empty_css.js")["default"];
var scrollBarWidth = {};
function ModalBase(props) {
  var _themeContext$scrollC;
  var themeContext = (0, _react.useContext)(_context7["default"]);
  var modalContext = (0, _react.useContext)(_context8["default"]);
  var _themeContext$additio = themeContext.additionalStyles,
    additionalStyles = _themeContext$additio === void 0 ? {} : _themeContext$additio,
    useStyle = themeContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.modal || defaultStyle : _props$classNames,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? _Container["default"] : _props$Component,
    _props$ComponentProps = props.ComponentProps,
    ComponentProps = _props$ComponentProps === void 0 ? {} : _props$ComponentProps,
    _props$BackdropCompon = props.BackdropComponent,
    BackdropComponent = _props$BackdropCompon === void 0 ? 'div' : _props$BackdropCompon,
    _props$BackdropCompon2 = props.BackdropComponentProps,
    BackdropComponentProps = _props$BackdropCompon2 === void 0 ? {} : _props$BackdropCompon2,
    onBackdropClick = props.onBackdropClick,
    _props$ContentCompone = props.ContentComponent,
    ContentComponent = _props$ContentCompone === void 0 ? 'div' : _props$ContentCompone,
    _props$ContentCompone2 = props.ContentComponentProps,
    ContentComponentProps = _props$ContentCompone2 === void 0 ? {} : _props$ContentCompone2,
    children = props.children,
    effect = props.effect,
    _props$open = props.open,
    open = _props$open === void 0 ? false : _props$open,
    keepMounted = props.keepMounted,
    isMounted = props.isMounted,
    _props$waitBeforeClos = props.waitBeforeClose,
    waitBeforeClose = _props$waitBeforeClos === void 0 ? 0 : _props$waitBeforeClos,
    _props$disableScroll = props.disableScroll,
    disableScroll = _props$disableScroll === void 0 ? true : _props$disableScroll,
    onOpen = props.onOpen,
    onClose = props.onClose;
  var _props$scrollElement = props.scrollElement,
    scrollElement = _props$scrollElement === void 0 ? (_themeContext$scrollC = themeContext.scrollContainer) === null || _themeContext$scrollC === void 0 ? void 0 : _themeContext$scrollC.current : _props$scrollElement;
  var container;
  var componentRef = (0, _react.useRef)();
  function getContainer() {
    var _themeContext$rootCon;
    var containerElement = props.getPortalElement ? props.getPortalElement() : null;
    if (containerElement && document.body.contains(containerElement)) {
      container = containerElement;
    } else if (props.portalElement && document.body.contains(props.portalElement)) {
      container = props.portalElement;
    } else if (modalContext.portalElement && document.body.contains(modalContext.portalElement)) {
      container = modalContext.portalElement;
    } else if ((_themeContext$rootCon = themeContext.rootContainer) !== null && _themeContext$rootCon !== void 0 && _themeContext$rootCon.current && document.body.contains(themeContext.rootContainer.current)) {
      container = themeContext.rootContainer.current;
    } else {
      container = document.body;
    }
  }
  if (typeof window !== 'undefined') {
    getContainer();
  }
  if (!scrollElement && typeof window !== 'undefined') {
    scrollElement = document.body;
  }
  var _useState = (0, _react.useState)(open),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _open = _useState2[0],
    _setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(isMounted || false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    mounted = _useState4[0],
    setMounted = _useState4[1];
  var _openSync = (0, _react.useRef)(_open);
  function setOpen(_x) {
    return _setOpen2.apply(this, arguments);
  }
  function _setOpen2() {
    _setOpen2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(value) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!(value !== _openSync.current)) {
              _context5.next = 20;
              break;
            }
            _openSync.current = value;
            if (!value) {
              _context5.next = 6;
              break;
            }
            getContainer();
            _context5.next = 10;
            break;
          case 6:
            if (!waitBeforeClose) {
              _context5.next = 10;
              break;
            }
            if (componentRef.current) {
              componentRef.current.classList.remove(classNames.showContent);
            }
            _context5.next = 10;
            return new Promise(function (resolve) {
              return setTimeout(resolve, waitBeforeClose);
            });
          case 10:
            _context5.next = 12;
            return _setOpen(value);
          case 12:
            if (!(value && onOpen)) {
              _context5.next = 17;
              break;
            }
            _context5.next = 15;
            return onOpen();
          case 15:
            _context5.next = 20;
            break;
          case 17:
            if (!(!value && onClose)) {
              _context5.next = 20;
              break;
            }
            _context5.next = 20;
            return onClose();
          case 20:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _setOpen2.apply(this, arguments);
  }
  function _toggleOpen2() {
    return _toggleOpen.apply(this, arguments);
  }
  function _toggleOpen() {
    _toggleOpen = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return setOpen(!_openSync.current);
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _toggleOpen.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setOpen: setOpen,
          toggleOpen: function () {
            var _toggleOpen3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
              var currentOpen;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    currentOpen = _openSync.current;
                    _context.next = 3;
                    return _toggleOpen2();
                  case 3:
                    return _context.abrupt("return", !currentOpen);
                  case 4:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            function toggleOpen() {
              return _toggleOpen3.apply(this, arguments);
            }
            return toggleOpen;
          }(),
          getOpen: function getOpen() {
            return _openSync.current;
          }
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setOpen: function () {
              var _setOpen3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              function setOpen() {
                return _setOpen3.apply(this, arguments);
              }
              return setOpen;
            }(),
            toggleOpen: function () {
              var _toggleOpen4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              function toggleOpen() {
                return _toggleOpen4.apply(this, arguments);
              }
              return toggleOpen;
            }(),
            getOpen: function getOpen() {}
          }
        });
      }
    };
  });
  if (classNames !== additionalStyles.modal) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var isRootModal = !modalContext.portalElement;
  (0, _react.useEffect)(function () {
    if (typeof scrollBarWidth.current === 'undefined') {
      setTimeout(function () {
        if (typeof scrollBarWidth.current === 'undefined') {
          var scrollBox = document.createElement('div');
          scrollBox.style.visibility = 'hidden';
          scrollBox.style.position = 'absolute';
          scrollBox.style.overflow = 'scroll';
          document.body.appendChild(scrollBox);
          scrollBarWidth.current = scrollBox.offsetWidth - scrollBox.clientWidth;
          document.body.removeChild(scrollBox);
        }
      }, 4000);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (container && scrollElement && isRootModal && disableScroll) {
      if (_open) {
        var scrollIsVisible = scrollElement === document.body ? scrollElement.scrollHeight > window.innerHeight : scrollElement.scrollHeight > scrollElement.clientHeight;
        if (scrollIsVisible && scrollBarWidth.current) {
          scrollElement.classList.add(classNames.scrollIsVisible, classNames.scrollElementOpen);
          if (scrollElement.style.getPropertyValue('--vlm-modal-scrollbar-width') !== scrollBarWidth.current + 'px') {
            scrollElement.style.setProperty('--vlm-modal-scrollbar-width', scrollBarWidth.current + 'px');
          }
        } else {
          setTimeout(function () {
            scrollElement.classList.add(classNames.scrollElementOpen);
          }, 500);
        }
      } else {
        scrollElement.classList.remove(classNames.scrollElementOpen, classNames.scrollIsVisible);
      }
    }
  }, [_open]);
  (0, _react.useEffect)(function () {
    if (keepMounted) {
      setMounted(true);
    }
  }, []);
  var lastPropsOpen = (0, _react.useRef)(props.open);
  (0, _react.useEffect)(function () {
    try {
      if (typeof props.open !== 'undefined' && lastPropsOpen.current !== props.open) {
        if (_open !== props.open) {
          lastPropsOpen.current = props.open;
          var newOpen = props.open;
          setOpen(newOpen);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [props.open]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, container && _open || container && keepMounted && mounted ? /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react["default"].createElement(_context8["default"].Provider, {
    value: {
      portalElement: container,
      position: modalContext.position
    }
  }, /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, themeContext.rootContainer && container === themeContext.rootContainer.current ? {
    containerVariant: 'root'
  } : {}, ComponentProps, {
    defaultClassName: (0, _clsx5["default"])(classNames.modal, (0, _defineProperty2["default"])({}, classNames.positionAbsolute, modalContext.position === 'absolute'), (0, _defineProperty2["default"])({}, classNames.keepMounted, keepMounted), (0, _defineProperty2["default"])({}, classNames.open, _open), (0, _defineProperty2["default"])({}, classNames.showContent, _open), ComponentProps.defaultClassName),
    ref: function ref(e) {
      componentRef.current = e;
      if (ComponentProps.ref) {
        if (typeof ComponentProps.ref === 'function') {
          ComponentProps.ref(e);
        } else if (ComponentProps.ref && typeof ComponentProps.ref === 'object') {
          ComponentProps.ref.current = e;
        }
      }
    }
  }), BackdropComponent ? /*#__PURE__*/_react["default"].createElement(BackdropComponent, Object.assign({}, BackdropComponentProps, {
    className: (0, _clsx5["default"])(classNames.backdrop, BackdropComponentProps.className),
    onClick: (/*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(e) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!onBackdropClick) {
                _context4.next = 3;
                break;
              }
              _context4.next = 3;
              return onBackdropClick(e);
            case 3:
              if (!BackdropComponentProps.onClick) {
                _context4.next = 6;
                break;
              }
              _context4.next = 6;
              return BackdropComponentProps.onClick(e);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x2) {
        return _ref.apply(this, arguments);
      };
    }())
  })) : null, /*#__PURE__*/_react["default"].createElement(ContentComponent, ContentComponentProps, children))), container) : null);
}